export default {
  SET_sended_ics(state, payload) {
    state.sended_ics = payload
  },
  SET_received_ics(state, payload) {
    state.received_ics = payload
  },
  SET_all_ics(state, payload) {
    state.all_ics = payload
  },
}
